import './my-events.scss';

const MyEvents: React.FC = function () {
  return <div>This is a component!</div>;
};

export default MyEvents;
